import { useEffect, useState } from 'react';
import assetPreloader from '../../services/assetPreloader';
import * as workboxCacheService from '../../services/workboxCacheService';
import connectivityService from '../../services/connectivityService';

/**
 * Componente para inicialização da aplicação
 * 
 * Este componente:
 * 1. Carrega assets críticos antes de exibir a aplicação
 * 2. Sincroniza o cache do service worker
 * 3. Verifica a conectividade
 */
function AppInitializer({ children, onInitialized }) {
  const [isInitialized, setIsInitialized] = useState(false);
  
  // Inicializar a aplicação
  useEffect(() => {
    // Função para inicializar o app
    const initializeApp = async () => {
      try {
        // Verificar serviço de conectividade
        const connectionState = connectivityService.getConnectionState();
        console.log('Estado de conectividade:', connectionState);
        
        // 1. Realizar sincronização com service worker
        await workboxCacheService.syncWithServiceWorker();
        
        // 2. Carregar assets críticos em segundo plano
        const highPriorityRoutes = ['/', '/tela1-1', '/tela2'];
        
        // Iniciar carregamento de assets em segundo plano
        for (const route of highPriorityRoutes) {
          assetPreloader.preloadRouteAssets(route);
        }
        
        // Permitir que a aplicação continue mesmo enquanto os assets carregam
        setIsInitialized(true);
        if (onInitialized) onInitialized();
        
      } catch (error) {
        console.error('Erro na inicialização:', error);
        
        // Mesmo com erro, continuar
        setIsInitialized(true);
        if (onInitialized) onInitialized();
      }
    };
    
    // Iniciar processo de inicialização
    initializeApp();
  }, [onInitialized]);
  
  // Se a inicialização estiver completa, mostrar a aplicação
  if (isInitialized) {
    return children;
  }
  
  // Retornar null enquanto inicializa para não mostrar nada
  return null;
}

export default AppInitializer; 